<template>
  <v-sheet color="grey-darken-4" theme="dark">
    <v-container>
      <v-row>
        <v-col>
          <h2 class="text-h5 text-sm-h4 text-center font-weight-bold">
            What our customers are saying...
          </h2>
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-carousel
            :show-arrows="false"
            crossfade
            cycle
            height="180"
            hide-delimiters
          >
            <v-carousel-item v-for="(item, i) in testimonials" :key="i">
              <v-sheet height="100%">
                <v-row class="fill-height" align="center" justify="center">
                  <v-col class="text-body-1 text-center">
                    <span style="font-size: 120%; line-height: 1.8rem"
                      >“{{ item.text }}”</span
                    >
                  </v-col>
                </v-row>
              </v-sheet>
            </v-carousel-item>
          </v-carousel>
        </v-col>
      </v-row>
    </v-container>
  </v-sheet>
</template>

<script setup lang="ts">
const testimonials = [
  {
    text: 'Had my truck ceramic coated. Was only expecting the outside to look great, but was pleasantly surprised to see they detailed the heck out of the interior as well. It’s a large truck so they had two people work on it and it was done so quickly. Looks amazing!!!'
  },
  {
    text: 'Came in with a Groupon and they over delivered. My car looks great!'
  },
  {
    text: 'I’ve relied on West Wind Automotive for almost 2 decades, because they are incredibly skilled, professional and customer centric. They’re great to work with every time an accident occurs.'
  },
  {
    text: 'Great people to work with, and got the car fixed like new and on time. Really nice work, as always! Thanks!!'
  },
  {
    text: 'Excellent service after my accident. Car was ready on the date promised and I was kept informed. They even went the extra mile and helped arrange for my loaner vehicle. Excellent customer service and work. Car is as good as new.'
  },
  {
    text: 'This was my first time coming to West Wind. It was great! I would recommend them to everyone. Everyone was friendly and transparent with all the repairs.'
  },
  {
    text: 'West Wind Auto did a great job repairing my car after an accident. They were professional, skilled, timely and reasonably priced. I highly recommend them!'
  },
  {
    text: 'The team at west wind Automotive did an amazing job on my car. When I came to pick it up, it was spotless and so clean. The staff is so friendly and easy to work with!'
  }
]
</script>
